<script setup>
import {ref, watch, computed, inject, onMounted, onBeforeUnmount, getCurrentInstance} from 'vue'
import $store from '@/store';
import $api from '@/api';
import showNotice from "@/components/common/notice/notice.js";
import award from "@/components/common/award2/index.vue";
import computeNumber from "@/utils/calcTotal.js";
import handleResponse from "@/utils/handleResponseData.js";
import loadmore from "@/components/common/loadmore/index.vue";
//冻结皮肤弹框开关
import {mockSkinslist} from "@/page/bank/mock.js";
import eventEmitter from "@/utils/emitter.js";
import i18n from "@/i18n";
//注入推送数据
const globalModalData = inject('globalModalData')
const {t: $t, locale} = i18n.global;
const {proxy} = getCurrentInstance();
//冻结皮肤弹框开关
const freezeSkinVisible = ref(false)
const freezeSkinIds = ref([])//选中的未抵押道具id数组
const freezeSkinList = ref([])//选中的未抵押道具
const dischargeSkinIds = ref([])//选中的冻结道具(即点击冻结道具选择解冻)
const oldDiyaTotalBean = ref(0)

//选择要冻结的皮肤
function handleSelectFreezeSkins(item) {
  if (item.is_dy === 1) {
    if (dischargeSkinIds.value.includes(item.id)) {
      dischargeSkinIds.value = dischargeSkinIds.value.filter(id => id !== item.id)
      skinsList.value.data_s.push(item)
      return;
    }
    dischargeSkinIds.value.push(item.id)
    skinsList.value.data_s = skinsList.value.data_s.filter(v => v.id !== item.id)
  } else {
    if (freezeSkinIds.value.includes(item.id)) {
      freezeSkinIds.value = freezeSkinIds.value.filter(id => id !== item.id)
      freezeSkinList.value = freezeSkinList.value.filter(v => v.id !== item.id)
      return
    }
    freezeSkinIds.value.push(item.id)
    freezeSkinList.value.push(item)
  }

}

const freezeSkinTotalPrice = computed(() => {
  const data_s_totalBean = skinsList.value.data_s.reduce((total, item) => {
    return computeNumber(total, "+", parseFloat(item.bean)).result;
  }, 0)
  return freezeSkinList.value.reduce((total, item) => {
    return computeNumber(total, "+", parseFloat(item.bean)).result;
  }, data_s_totalBean)
})

//冻结皮肤到银行(存钱罐),调用接口
function handleFreezeSkinsToBank() {
  if (freezeSkinIds.value.length <= 0 && dischargeSkinIds.value.length <= 0) {
    return
  }
  console.log('freezeSkinIds:', freezeSkinIds.value);
  const data = freezeSkinIds.value.map(v => ({id: v}))
  const data_s = dischargeSkinIds.value.map(v => ({id: v}))
  const params = {
    data,
    data_s,
    atm_id: globalModalData.value.atm_id
  }
  const val = computeNumber(freezeSkinTotalPrice.value, "-", oldDiyaTotalBean.value).result
  console.log('冻结数据', val, params);

  $api.user.coinImpawn(params).then(res => {
    const resp = handleResponse(res)
    if (!resp) return console.log("未知错误", res.message);
    showNotice("s", {desc: res.message});
    proxy.$EventBus.emit("upd", {type: "increment", paytype: 'refund', bank: true, bankType: "decrement", val: val});
    closeFreezeSkinsModal()
  })
  //调用冻结接口,存入服务器数据
  // user.freezeSkins({
  //   skin_ids: freezeSkinIds.value,
  // }).then(res => {
  //   handleResponse(res, {
  //     success: () => {
  //       showNotice("s", { desc: "冻结成功" });
  //       //刷新用户信息
  //       u.getUserInfo()
  //       //关闭存换弹框,触发存款事件,depositFundsValue重置
  //       closeFreezeSkinsModal()
  //     },
  //     fail: () => {
  //       showNotice("f", { desc: "冻结失败" });
  //     }
  //   })
  // })

}


//弹框关闭
function closeFreezeSkinsModal() {
  freezeSkinVisible.value = false
  freezeSkinIds.value = []
  freezeSkinList.value = []
  dischargeSkinIds.value = []
  globalModalData.value = {}
  oldDiyaTotalBean.value = 0
  eventEmitter.emit("api:freezeSkin", 'close');
}


//列表数据
const skinsList = ref({
  data: [],
  data_s: [],//已冻结皮肤道具
  current_page: 1,
  last_page: 0,
  per_page: 10,
  total: 0,
});

function initSkinsList(params, load = false) {
  $api.user.coinCollateral({params: params}).then(res => {
    const resp = handleResponse(res);
    if (!resp) return console.log("未知错误", res.message);
    skinsList.value.current_page = resp.current_page;
    skinsList.value.last_page = resp.last_page;
    skinsList.value.per_page = resp.per_page;
    skinsList.value.total = resp.total;
    if (skinsList.value.current_page >= skinsList.value.last_page) {
      loadStatus.value = "noMore";
      loadMsg.value = "noMore";
    } else {
      loadStatus.value = "loadMore";
      loadMsg.value = "loadMore";
    }
    if (load) {
      const originalLength = skinsList.value.data.length;
      skinsList.value.data = skinsList.value.data.concat(resp.data);
      startNewTimers(originalLength)
      return;
    }
    skinsList.value.data = resp.data;
    //把第一页数据全部选中(在总金额<globalModalData.value.bean的情况下把数据放入选中数组内)
    if (res.data_s.length <= 0) {
      freezeSkinList.value = firstSelect(resp.data, parseFloat(globalModalData.value.bean))
      freezeSkinList.value.map(v => freezeSkinIds.value.push(v.id))
    }
    oldDiyaTotalBean.value = res.data_s.reduce((total, item) => {
      return computeNumber(total, "+", parseFloat(item.bean)).result;
    }, 0)
    skinsList.value.data_s = res.data_s;
    skinsList.value.data.unshift(...skinsList.value.data_s);
    startFreezeAll(skinsList.value.data)
  })
}


//弹框选中道具 在不超过总和globalModalData.value.bean的情况下，尽可能多地放入数据。
function firstSelect(arr, maxSum) {
  // 先按bean值从小到大排序，这样可以放入更多小对象
  const sortedArr = [...arr].sort((a, b) => a.bean - b.bean);

  let currentSum = 0;
  const arr2 = [];

  for (const item of sortedArr) {
    if (currentSum + parseFloat(item.bean) <= maxSum) {
      arr2.push(item);
      currentSum += parseFloat(item.bean);
    } else {
      // 尝试替换已选中的较大对象
      for (let i = 0; i < arr2.length; i++) {
        if (arr2[i].bean > parseFloat(item.bean) &&
            currentSum - arr2[i].bean + parseFloat(item.bean) <= maxSum) {
          currentSum = currentSum - arr2[i].bean + parseFloat(item.bean);
          arr2[i] = item;
          break;
        }
      }
    }
  }
  return arr2
}

const loadStatus = ref("loadMore"); //loadmore 加载数量
const loadMsg = ref($t("loadMore"));

function loadMore() {
  console.log('加载更多')
  if (skinsList.value.current_page >= skinsList.value.last_page) {
    loadStatus.value = "noMore";
    loadMsg.value = "noMore";
    return;
  }
  skinsList.value.current_page++;
  loadStatus.value = "loading";
  loadMsg.value = "loading";
  const params = {
    page: skinsList.value.current_page,
    atm_id: globalModalData.value.atm_id
  }
  initSkinsList(params, true);
}

const formattedTime = ref()
let timer = null;
// 给定的时间戳，单位为秒
const timestampInSeconds = globalModalData.value?.remaining_time || 0;
// 将时间戳转换为对应的小时、分钟、秒数
let hours = Math.floor(timestampInSeconds / 3600);
let remainingSeconds = timestampInSeconds % 3600;
let minutes = Math.floor(remainingSeconds / 60);
remainingSeconds %= 60;


// 定义更新时间显示的函数
const updateTimeDisplay = () => {
  // 格式化小时数，不足两位补零
  const hoursStr = String(hours).padStart(2, "0");
  // 格式化分钟数，不足两位补零
  const minutesStr = String(minutes).padStart(2, "0");
  // 格式化秒数，不足两位补零
  const secondsStr = String(remainingSeconds).padStart(2, "0");

  // 更新页面上显示的时间内容
  formattedTime.value = `${hoursStr}:${minutesStr}:${secondsStr}`;

  // 时间每秒减1
  remainingSeconds--;
  if (remainingSeconds < 0) {
    if (minutes > 0) {
      minutes--;
      remainingSeconds = 59;
    } else if (hours > 0) {
      hours--;
      minutes = 59;
      remainingSeconds = 59;
    } else {
      // 时间耗尽，可在这里添加相应处理逻辑，比如停止定时器等
      clearInterval(timer);
      formattedTime.value = "";
      return;
    }
  }
};

//格式化显示 时分秒
const formatTimeHoursStr = ([hours, minutes, seconds]) => {
  const padZero = (num) => String(num).padStart(2, "0");
  return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
};

function formatTimeHours(seconds) {
  if (seconds <= 0) return [0, 0, 0];

  const hours = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
  const minutes = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
  const secondsLeft = (seconds % 60).toString().padStart(2, "0");

  return [hours, minutes, secondsLeft];
}

const freezeTimers = ref([])

//冻结皮肤启动所有倒计时
function startFreezeAll(data) {
  data.forEach((item, index) => {
    if (item.is_dy === 1) {
      freezeTimers.value[index] = setInterval(() => {
        console.log('dyy')
        if (item.remaining_time >= 0) {
          item.remaining_time--;
        } else {
          clearInterval(freezeTimers.value[index]);
        }
      }, 1000);
    }
  });
}

/**
 * 冻结道具倒计时
 * 独立启动新计时器函数‌
 * 专门处理新增数据的倒计时逻辑
 * @param startIndex
 */
function startNewTimers(startIndex) {
  skinsList.value.data.slice(startIndex).forEach((item, offset) => {
    const actualIndex = startIndex + offset
    if (item.is_dy === 1 && !freezeTimers.value[actualIndex]) {
      freezeTimers.value[actualIndex] = setInterval(() => {
        if (item.remaining_time >= 0) {
          item.remaining_time--
        } else {
          clearInterval(freezeTimers.value[actualIndex])
          freezeTimers.value[actualIndex] = null
        }
      }, 1000)
    }
  })
}

onMounted(() => {
  const params = {
    page: skinsList.value.current_page,
    atm_id: globalModalData.value.atm_id
  }
  initSkinsList(params)
  // timer = setInterval(updateTimeDisplay, 1000);
})
onBeforeUnmount(() => {
  // clearInterval(timer);
  freezeTimers.value.forEach((timer) => {
    timer && clearInterval(timer);
  })
})

const freezeIngStyle = computed(() => {
  return (item) => {
    if (item.is_dy === 1) {
      return !dischargeSkinIds.value.includes(item.id);

    } else {
      return freezeSkinIds.value.includes(item.id);
    }
  }
})

</script>

<template>
  <!--  冻结皮肤弹框-->
  <myModal
      class="freeze-skins-modal"
      :visible="freezeSkinVisible"
      :z-index="1001"
      @close="closeFreezeSkinsModal"
  >
    <template #body>
      <div class="freeze-skins-container">
        <div class="title">{{ $t("REVISE SKINS") }}</div>
        <div class="skins-list award-list" v-if="skinsList.data.length>0">
          <div class="skin award"
               :style="{ borderBottomColor: $dynamicAwardColor(aitem) }"
               v-for="aitem in skinsList.data"
               :key="aitem.id">
            <div class="tf" :class="{ 'freeze-skin': freezeIngStyle(aitem) }">
              <award
                  :img="aitem.cover"
                  :name="aitem.name"
                  :abrad="aitem.dura_alias"
                  :status="aitem.status"
              ></award>
              <div class="icon icon-left">
                <span class="balance fz15">{{ aitem.bean }}</span>
              </div>
            </div>
            <div class="icon icon-center">
              <a-button class="freeze-btn" :class="{ 'freezing-btn': freezeIngStyle(aitem) }"
                        @click="handleSelectFreezeSkins(aitem)">
                {{ freezeIngStyle(aitem) ? $t("FREEZING") : $t("FREEZE") }}
                <template #icon>
                  <img src="@/assets/images/bank/freezeing.png" v-if="freezeIngStyle(aitem)" alt=""/>
                  <img src="@/assets/images/bank/freeze.png" v-else alt=""/>
                </template>
              </a-button>
            </div>
            <div class="icon icon-right" v-if="freezeIngStyle(aitem)">
              <!--              remaining_time 剩余秒数-->
              <!--              <div class="time">{{ formattedTime }}</div>-->
              <div class="time" v-if="aitem.remaining_time>=0">{{
                  formatTimeHoursStr(formatTimeHours(aitem.remaining_time))
                }}
              </div>
            </div>
          </div>
          <loadmore
              class="freeze-load"
              @click="loadMore"
              :status="loadStatus"
              :loadMsg="loadMsg"
          ></loadmore>
        </div>
        <div class="noskins-list" v-else>
          <div class="noaward">{{ $t("unfreezeInfo") }}
          </div>
        </div>

        <div class="footer">
          <div class="left">
            <div class="info">
              {{ $t("Total Freeze Funds") }}
            </div>
            <div class="info-value">
              <span class="balance freeze-skins-bean">{{ freezeSkinTotalPrice }}</span>
              <span>&nbsp;/&nbsp;</span>
              <span class="balance_normal skinsback-pay-bean">{{ globalModalData.bean }}</span>
            </div>
          </div>
          <div class="right">
            <a-button class="freeze-skins-btn" @click="handleFreezeSkinsToBank">{{ $t('save') }}</a-button>
          </div>
        </div>
      </div>
    </template>


  </myModal>
</template>

<style scoped lang="scss">
//冻结皮肤弹框
.freeze-skins-modal {
  :deep(.ant-modal) {
    width: max-content !important;

    .ant-modal-close-x {

      img {
        width: 0.14rem;
      }
    }

    .ant-modal-content {
      width: 9.1rem;
      height: 8.2rem;
      background: #131723;
      box-sizing: border-box;
      border-radius: .1rem;

      .freeze-skins-container {
        background: #131723;
        border: 0.01px solid transparent;
        box-sizing: border-box;

        .title {
          @extend %flex-all-center;
          font-weight: bold;
          font-size: .2rem;
          color: #FFFFFF;
          margin-top: .5rem;
          margin-bottom: .2rem;
        }

        .skins-list {
          margin-left: .4rem;
          margin-right: .28rem;
          height: 6.2rem;
          overflow-y: scroll;
          @extend %scrollbar2;
          display: flex;
          flex-wrap: wrap;

          .skin {
            flex-shrink: 0;
            width: 2rem;
            height: 2.2rem;
            margin-right: .1rem;
            margin-bottom: .1rem;
            cursor: pointer;

            &:hover {
              opacity: 0.8;
            }

            .freeze-btn {
              min-width: .82rem;
              width: max-content;
              height: .24rem;
              background: #44B0DD;
              border-radius: .12rem;
              @extend %flex-all-center;
              font-weight: bold;
              font-size: .12rem;
              color: #FFFFFF;
              cursor: pointer;

              img {
                width: .14rem;
                height: .16rem;
                margin-right: .04rem;
                transform: translateY(-.01rem);
              }
            }

            .freezing-btn {
              color: #44B0DD;
              background: #034966;
            }

            //通过嵌套一层,给嵌套层设置opacity,使子元素不受opacity影响
            .tf {
              height: inherit;
              width: inherit;
            }
          }

          .freeze-skin {
            opacity: .3;
          }


          /* 每行第4个元素右边距清零 */
          .skin:nth-child(4n) {
            margin-right: 0;
          }

          .award {
            background: #1B2132;

            .icon-left {
              .fz15 {
                font-weight: 400;
                font-size: .15rem;
              }
            }

            .icon-right {
              .time {
                min-width: .8rem;
                width: max-content;
                @extend %flex-all-center;
                padding: 0 .1rem;
                height: .24rem;
                background: #283047;
                border-radius: .12rem;
                font-weight: 400;
                font-size: .12rem;
                color: #9BA5C3;
              }
            }

            .icon-center {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          .freeze-load {
            width: 100%;
            margin-top: .14rem;
          }
        }

        .noskins-list {
          height: 6.2rem;
          background-image: url("@/assets/images/bank/noaward.png");
          background-repeat: no-repeat;
          background-position: center 35%;
          background-size: 1.93rem .96rem;
          position: relative;

          .noaward {
            font-weight: 400;
            font-size: .2rem;
            color: #5E677A;
            position: absolute;
            left: 50%;
            top: 60%;
            transform: translate(-50%, -50%);
            width: 5.94rem;
            text-align: center;
          }
        }

        .award-list {
          margin-bottom: .2rem;
        }

        .footer {
          margin-top: .2rem;
          height: 1rem;
          background: #0E121E;
          border-radius: 0px 0px .1rem .1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 .4rem;

          .left {
            font-weight: 400;
            font-size: .16rem;
            color: #6F7485;

            .info-value {
              .freeze-skins-bean {
                font-weight: bold;
                font-size: .26rem;
                color: #20DFB9;
              }

              .skinsback-pay-bean {
                color: inherit;
                font-weight: inherit;
                font-size: inherit;
              }
            }
          }

          .right {
          }


          .freeze-skins-btn {
            width: 2.1rem;
            height: .5rem;
            background: $active-color;
            border-radius: .25rem;
            font-weight: bold;
            font-size: .16rem;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
</style>